<div *ngIf="showWarning" role="alert" class="alert alert-warning">
	<strong>Warning:</strong> 
	<div>
		Are you sure you want to overwrite your changes?
	</div>
	<div class="text-right margin-top-10">
		<eze-button context="danger" style="margin-right: 10px;" (click)="forceUpdate()">Yes</eze-button>
		<eze-button (click)="cancelUpdate()">Cancel</eze-button>
	</div>
</div>

<div class="row" *ngIf="profile" style="margin-top: 10px; margin-bottom: 10px;">
	<div class="col-xs-12">
		<eze-input-container label="Prefill registration form with:">
			<select ezeInput id="who-is-registering" [formControl]="formControl">
				<option value="" disabled>Please select</option>
				<option value="-1">My child/ dependent</option>
				<option value="0">My profile</option>
			</select>
		</eze-input-container>
	</div>
</div>